import { FormattedMessage } from 'react-intl'

import Container from 'app/components/base/Container'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import { DownloadAppSection } from './components/DownloadAppSection'
import { ImageSection } from './components/ImageSection'
import { ScanWithPhoneSection } from './components/ScanWithPhoneSection'
import { useCheckUserRedirect } from './hooks/useCheckUserRedirect'

const GetAppView = () => {
  useCheckUserRedirect()

  return (
    <Container
      maxWidth="lg"
      sx={{ px: 2, mt: { xs: 4, md: 10 }, pb: { xs: 6, md: 10 } }}
    >
      <Stack
        direction="row"
        spacing={{ xs: 4, md: 6 }}
        sx={{ justifyContent: 'space-between' }}
      >
        <Stack direction="column" sx={{ maxWidth: { xs: '100%', md: 540 } }}>
          <Text
            variant="h1"
            component="h1"
            sx={{
              fontSize: { md: 40, lg: 48 },
              lineHeight: { md: '50px', lg: '65px' },
              textAlign: { xs: 'center', md: 'start' }
            }}
          >
            <FormattedMessage defaultMessage="Buy Smart, Sell Fast – All in One App" />
          </Text>

          <Text
            variant="body1"
            component="p"
            sx={{ mt: 2, textAlign: { xs: 'center', md: 'start' } }}
          >
            <FormattedMessage defaultMessage="Find, buy, and sell your auto parts in a dedicated marketplace app. Our innovative app helps you trade instantly." />
          </Text>

          <DownloadAppSection />

          <ScanWithPhoneSection />
        </Stack>

        <ImageSection />
      </Stack>
    </Container>
  )
}

export default GetAppView
